// FAQs Accordion Functionality
class ProductFAQs {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.bindEvents();
    });
  }

  bindEvents() {
    const faqButtons = document.querySelectorAll('[data-faq-button]');
    
    faqButtons.forEach(button => {
      button.addEventListener('click', (e) => this.toggleFAQ(e));
    });
  }

  toggleFAQ(e) {
    e.preventDefault();
    
    const button = e.currentTarget;
    const faqItem = button.closest('[data-faq-item]');
    const isOpen = faqItem.classList.contains('is-open');
    const singleOpen = button.getAttribute('data-single-open') === 'true';

    // Close other FAQs if single_open is enabled
    if (singleOpen && !isOpen) {
      this.closeAllFAQs();
    }

    // Toggle current FAQ
    if (isOpen) {
      this.closeFAQ(faqItem, button);
    } else {
      this.openFAQ(faqItem, button);
    }
  }

  openFAQ(faqItem, button) {
    faqItem.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
  }

  closeFAQ(faqItem, button) {
    faqItem.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
  }

  closeAllFAQs() {
    const openFAQs = document.querySelectorAll('[data-faq-item].is-open');
    
    openFAQs.forEach(faqItem => {
      const button = faqItem.querySelector('[data-faq-button]');
      this.closeFAQ(faqItem, button);
    });
  }
}

// Initialize FAQs
new ProductFAQs();